var $7123a3cf907d0f3b$exports = {};
$7123a3cf907d0f3b$exports = {
    "replaceMessage": `Upu\u{15B}\u{107} plik, aby zast\u{105}pi\u{107}`
};


export {$7123a3cf907d0f3b$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
